export default __webpack_public_path__ + "static/media/logo.1deb9b97.png";